import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7ntwa7s8m: FaireProductEntity = {
  token: "p_e7ntwa7s8m",
  type: "product",
  name: "FEKKAI Technician Color Care Shampoo & Conditioner Hair Set",
  brandToken: "b_350t9wyo",
  brandName: "Best Beauty Group",
  imageUrl:
    "https://cdn.faire.com/fastly/a493ca09222f54d87f433bf467b51d23331503286c20e8b6671e1b7292ff0a6e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a9a9ab245e6c44bce73bac7182624844c8b4a8e3b53fe82f65bd901064f0844.jpeg",
    "https://cdn.faire.com/fastly/a366fa3208404b354557b02617665fd517ad5edf9c37cc1b3dc1af8cb71f1158.jpeg",
    "https://cdn.faire.com/fastly/e18d1fd5aef723078f300b5adfbc022aa39545e7b6e224cc69c60c15f9af82b6.jpeg",
    "https://cdn.faire.com/fastly/643dff73a1dfa7d46d3edf620f4ccf8abcf0d80f72b6c933456e2d2288bcdd8a.jpeg",
    "https://cdn.faire.com/fastly/bdfaa908b7e209756162463bc1c762135110687622239f042ba633d03bdc5879.jpeg",
  ],
  priceDollars: 8,
  description:
    "Size: 2 oz Trial Mini Set (1 Shampoo and 1 Conditioner)\n\nIntroducing the Technician Color Care Mini Collection by Frederic Fekkai, a perfect trio designed to nourish and protect color-treated hair. This luxurious set includes a Shampoo and Conditioner making it an ideal choice for personal pampering or as a thoughtful gift for a friend who values their vibrant locks.\n\nFormulated specifically for color-treated hair, this collection is enriched with essential ingredients that work together to maintain your hair's radiance and softness. The shampoo gently cleanses while infusing your strands with moisture, preventing color from fading. The conditioner provides deep hydration, ensuring your hair remains manageable and free from tangles. \n\nWith a creamy texture that glides effortlessly through the hair, each product in this collection is easy to use, leaving your locks feeling soft and silky after each wash. Simply apply the shampoo, follow with the conditioner as a weekly treat for maximum color protection.\n\nFrederic Fekkai is renowned for its commitment to quality and results, ensuring that your color-treated hair receives the expert care it deserves. Treat yourself or someone special to this exceptional mini collection and let your hair shine with brilliance and beauty!",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:06.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
